module.exports = __webpack_public_path__ + "static/loading1-29f73df514ff7776713c823045c3feb9.gif";